import { render } from "./add-videos-modal.vue?vue&type=template&id=69acf282"
import script from "./add-videos-modal.vue?vue&type=script&lang=js"
export * from "./add-videos-modal.vue?vue&type=script&lang=js"
script.render = render

export default script